<template>
  <BaseTableItemAction
    v-can:[editPermission]
    v-on="$listeners"
    v-bind="$attrs"
    icon="mdi-pencil"
    actionName="تعديل"
    :to="'/news/edit/' + this.item.id"
  >
    <slot></slot>
  </BaseTableItemAction>
</template>

<script>
import { WRITE_NEWS_PERMISSION } from "@/core/statics/Permissions";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      editPermission: WRITE_NEWS_PERMISSION,
    };
  },
};
</script>
